import * as React from "react";
import MenuItemDotBadge from "components/navigation/MenuItemDotBadge";
import useForwarderInputsBadgeCondition from "./useForwarderInputsBadgeCondition";
const ForwarderInputsTabDotBadge = ({ text }) => {
  const { hasIssues, title } = useForwarderInputsBadgeCondition();
  return /* @__PURE__ */ React.createElement(MenuItemDotBadge, { text, title: hasIssues ? title : "", showDot: hasIssues });
};
export default ForwarderInputsTabDotBadge;
